module.exports = __webpack_public_path__ + "img/Type=NL, Color=Navy.0a17cd54.svg";